import HeaderLogo from '../../components/HeaderLogo';

export default function SpaceDashboard() {
  return <HeaderLogo shortName="dashboard" />;
}
